
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { Doughnut } from 'vue-chartjs';
import Chart from 'chart.js';

Chart.defaults.global.defaultFontFamily = '\'Quicksand\', sans-serif';
Chart.defaults.global.defaultFontSize = 12;

@Component({
	name: 'DoughnutChart'
})
export default class DoughnutChart extends Mixins(Doughnut) {
	@Prop({ type: Object, required: true }) chartData!: DoughnutChartData;
	@Prop({ type: Object, default: () => ({}) }) options!: Record<string, any>;
	@Prop({ type: Number, required: false }) width!: number;
	@Prop({ type: Number, required: false }) height!: number;
	@Prop({ type: String, required: false }) chartId!: string;
	@Prop({ type: String, required: false }) cssClasses!: string;
	@Prop({ type: Object, required: false }) styles!: Record<string, string>;
	@Prop({ type: Array, required: false }) plugins!: any[];

	private mounted(): void {
		this.renderChart(this.chartData, this.options);
	}

	public updateChartData(newData: any): void {
		if (this.$data._chart) {
			// Update only the data values, not the entire chart
			this.$data._chart.data.datasets[0].data = [...newData.datasets[0].data];
			this.$data._chart.update({
				duration: 400,
				easing: 'easeInOutQuart'
			});
		}
	}
}
